import React, { useState,useEffect } from 'react';
import { formatDate,DownloadFile } from './Function';
import { useTranslation } from 'react-i18next';
import { usePage } from '../PageContext';
import { Card,Table,Placeholder } from 'react-bootstrap';
const AchievementsDetails = ({htaccess}) => 
{
    const { currentPage } = usePage();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Achievements,setAchievements] = useState([]);
    useEffect(()=>
    {
        const AchievementsDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"achievements/details/"+htaccess);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sa_id + "/achievementFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sa_id + "/achievementFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].achievementFile = el.upp;
                            result[i].achievementFileHi = el.upb;
                        });
                        setAchievements(result[0]);
                        currentPage(result[0]);
                    }).catch(error => 
                    {
                        console.error('AchievementsDetails File :', error);
                    });
                }
                if( global.config.IsPrint === true ) { console.info('AchievementsDetails : Result',result); }
            } 
            catch (error)
            {
                console.error('AchievementsDetails : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        AchievementsDetails();
        // eslint-disable-next-line
    },[htaccess])
    return (
        <Card className='mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase'>
                {t('AchievementDetails')}
            </Card.Header>
            <Card.Body>                    
            {isLoading ? (
                <Table responsive bordered className='mb-0'>
                <tbody>
                    {[...Array(5)].map((_,index)=>(
                    <tr key={index}>
                        <th className="table-success w-25"><Placeholder xs={10} /></th>
                        <td className="text-center"><Placeholder xs={10} /></td>
                    </tr>
                    ))}
                </tbody>
                </Table>
                ) : (
                <React.Fragment>
                {Achievements.sa_id > 0 ? (
                <Table responsive bordered className='mb-0'>
                <tbody>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Title')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (Achievements.sa_display_en === "1" ? Achievements.sa_name_hi || '' : Achievements.sa_name_hi || Achievements.sa_name) : Achievements.sa_name }}></th>
                    </tr>                                    
                    <tr>
                        <th className="table-success w-25 text-end">{t('Content')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (Achievements.sa_display_en === "1" ? Achievements.sa_description_hi || '' : Achievements.sa_description_hi || Achievements.sa_description) : Achievements.sa_description }}></th>            
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Departments')}:</th>
                        <td>{Achievements?.departments?.sd_id > 0 && appLanguage === 'hi' ? Achievements.departments.sd_fullname_hi || Achievements?.departments?.sd_fullname : Achievements?.departments?.sd_fullname}</td>
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Download')}:</th>
                        <td dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,Achievements.achievementFile,Achievements.achievementFileHi)}} />
                    </tr>  
                    <tr>
                        <th className="table-success w-25 text-end">{t('Date of Uploading')}:</th>
                        <td>{formatDate(Achievements.sa_date)}</td>
                    </tr>
                </tbody>
                </Table>
                ) : (
                    <div className='text-center lead fw-bold'>
                        {appLanguage === 'hi' ? 'हम वह उपलब्धि नहीं ढूंढ पाए जिसका विवरण हम आपको दिखाना चाहते थे।' : "We can't find the achievement whose details we wanted to show you."}
                    </div>
                )}
                </React.Fragment>
            )}             
            </Card.Body>
        </Card>
    );
}
export default AchievementsDetails;